export default __webpack_public_path__ + "static/media/unsere-2.688b86cb.jpg";